import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

export const fileUrl = (storagePath) => `${API}/files/${storagePath}`;

// Auth is carried by the httpOnly session cookie (sent automatically on same-site
// requests, including <a>/<img> navigations), so no token is embedded in the URL.
export const authFileUrl = (storagePath) => fileUrl(storagePath);

export function apiError(e, fallback = "Something went wrong. Please try again.") {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export default api;
